import { ReactComponent as NewBadge } from './svg/new_badge.svg';
import { ReactComponent as DownDoubleArrow } from './svg/down_double_arrow.svg';
import { ReactComponent as DailyFiveFlipIcon } from './svg/daily_five_flip.svg';
import { ReactComponent as DailyFiveTwinkleIcon } from './svg/daily_five_twinkle.svg';

import React, { useEffect, useState } from 'react';
import './App.css';
import { Box, Dialog } from '@mui/material';
import Lottie from 'lottie-react';
import pingAnimationData from './lotties/ping_knock.json';
import thumbUpAnimationData from './lotties/ping_thumb_up.json';
import timeCapsuleAnimationData from './lotties/time_capsule_waiting.json';
import pungAnimationData from './lotties/pung.json';
import mBoxOpenAnimationData from './lotties/mumble_box_open.json';
import SpaceBox from './components/SpaceBox';
import Header from './components/Header';
import DescriptionSection from './components/DescriptionSection';
import InfiniteMarquee from './components/InfiniteMarquee';
import Footer from './components/Footer';

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  return (
    <Box>
      <Dialog
        sx={{
          display: isMobile ? 'none' : 'block',
          '& .MuiDialog-paper': {
            borderRadius: '30px',
            boxShadow: 'none',
          },
        }}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <Box
          sx={{
            width: { sm: '561px' },
            height: { sm: '580px' },
            maxWidth: '561px',
            maxHeight: '580px',
          }}
        >
          <Box sx={{ padding: '24px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ fontSize: '18px', fontWeight: 800 }}>QR 코드 스캔</Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box
                  component={'img'}
                  src={'/images/close.png'}
                  sx={{ width: '30px', cursor: 'pointer' }}
                  onClick={() => {
                    setIsOpen(false);
                  }}
                />
              </Box>
            </Box>
            <SpaceBox height={108} />
            <Box
              component={'img'}
              src={'/images/qr_code.png'}
              sx={{ display: 'block', width: '218px', height: '218px', margin: 'auto' }}
            />
            <SpaceBox height={30} />
            <Box
              sx={{
                fontSize: '16px',
                textAlign: 'center',
                lineHeight: '26px',
                fontWeight: 400,
                color: 'text.secondary',
                opacity: '80%',
              }}
            >
              멈블은 모바일에서 사용 가능합니다.
              <br />
              휴대전화의 카메라로 QR 코드를 촬영해 주세요
            </Box>
          </Box>
        </Box>
      </Dialog>
      <Header setIsOpen={setIsOpen} isMobile={isMobile} />
      <WelcomeSection />
      <SpaceBox height={90} smHeight={170} />
      <DailyFiveSection />
      <SpaceBox height={120} smHeight={170} />
      <PingSection />
      <SpaceBox height={120} smHeight={170} />
      <TimeCapsuleSection />
      <SpaceBox height={120} smHeight={170} />
      <PungSection />
      <SpaceBox height={120} smHeight={170} />
      <MumbleBoxSection />
      <SpaceBox height={0.1} smHeight={5} />
      <DownloadSection setIsOpen={setIsOpen} isMobile={isMobile} />
      <Footer />
    </Box>
  );
}

function WelcomeSection() {
  return (
    <Box
      sx={{
        backgroundColor: 'primary.main',
        padding: { xs: '98px 0px 11px 0px', sm: '148px 0px 11px 0px' },
        textAlign: 'center',
      }}
    >
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        <NewBadge width={107} height={48} />
      </Box>
      <SpaceBox height={21}></SpaceBox>
      <Box sx={{ fontSize: { xs: '84px', sm: '190px' }, color: 'white', fontWeight: '800' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ position: 'relative' }}>
            <Box sx={{ display: 'flex' }}>
              하이
              <SpaceBox width={97} />
            </Box>

            <Box
              sx={{
                position: 'absolute',
                top: { xs: '-31px', sm: '-25px' },
                right: { xs: '-15px', sm: '-100px' },
                width: { xs: '130px', sm: '230px' },
              }}
            >
              <Lottie animationData={pingAnimationData} loop={true} />
            </Box>
            <Box
              sx={{
                position: 'absolute',
                right: { xs: '-39px', sm: '-126px' },
                top: { xs: '-32px', sm: '-80px' },
              }}
            >
              <Box
                component={'img'}
                src={'/images/stars.png'}
                sx={{ width: { xs: '47px', sm: '70px' } }}
              />
            </Box>
          </Box>
        </Box>
        <SpaceBox height={10} smHeight={20} />
        <Box>
          <Box sx={{ display: 'inline-block', position: { sm: 'relative' } }}>
            나 멈블!
            <Box
              sx={{
                top: '-80px',
                right: '-190px',
                position: { sm: 'absolute' },
                display: { xs: 'none', sm: 'block' },
                width: { xs: '107px', sm: '154px' },
              }}
            >
              <NewBadge width={'100%'} height={'100%'} />
            </Box>
          </Box>
        </Box>
      </Box>
      <SpaceBox height={112} />
      <Box
        sx={{
          display: {
            xs: 'block',
            sm: 'none',
          },
        }}
      >
        <DownDoubleArrow />
      </Box>
      <Box
        sx={{
          display: {
            xs: 'none',
            sm: 'block',
          },
        }}
      >
        <SpaceBox height={51} />
      </Box>
    </Box>
  );
}

function DailyFiveSection() {
  const [isDailyFiveFlipped, setIsDailyFiveFlipped] = useState(false);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setIsDailyFiveFlipped((prev) => !prev);
    }, 3000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const dailyFiveCards = [
    {
      imageSrc: '/images/daily_five_1.png',
      profileSrc: '/images/daily_five_profile_1.png',
      profileSrcs: ['/images/daily_five_profile_1.png'],
      name: '지영쓰',
      time: '방금 전',
      keyword: '청춘통온다',
      isActive: false,
    },
    {
      imageSrc: '/images/daily_five_2.png',
      profileSrc: '/images/daily_five_profile_2.png',
      profileSrcs: ['/images/daily_five_profile_2.png'],
      name: '김멈블',
      time: '2분 전',
      keyword: '집순이실패',
      record:
        '오늘은 집에만 있으려고 했는데 날씨가 너무 좋아서 안 나갈 수가 없다! 돗자리만 들고 나가서 잔디밭에 누우면 얼마나 좋게요~ 날씨가 만든 이렇게 좋았으면...',
      isActive: true,
    },
    {
      imageSrc: '/images/daily_five_3.png',
      profileSrc: '/images/daily_five_profile_3.png',
      profileSrcs: ['/images/daily_five_profile_3.png', '/images/daily_five_profile_4.png'],
      name: '스녕이님과 오연정이님',
      time: '10분 전',
      keyword: '여름이벌써',
      record: '',
      isActive: false,
    },
  ];
  const activeDailyFiveCard = dailyFiveCards[1];
  const peekDailyFiveCard = dailyFiveCards[2];

  return (
    <Box sx={{ paddingX: '20px', maxWidth: { sm: '600px', margin: 'auto' } }}>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <DescriptionSection
          subTitle="복잡한 내 마음, 어떻게 말하지?"
          mainTitle="설명은 생략, 오늘의 바이브로 통하기"
          description="AI가 분석한 5글자 카드 뒤에 숨어,<br/>애쓰지 않아도 내 상태를 가장 힙하게 보여주기."
        />
      </Box>
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        <Box
          sx={{
            textAlign: 'center',
            color: 'primary.main',
            fontWeight: 800,
            fontSize: '12px',
            lineHeight: '37px',
          }}
        >
          복잡한 내 마음, 어떻게 말하지?
        </Box>
        <Box
          sx={{
            textAlign: 'center',
            color: 'text.primary',
            fontWeight: 800,
            fontSize: '26px',
            lineHeight: '34px',
            textTransform: 'uppercase',
          }}
        >
          설명은 생략,
          <br />
          오늘의 바이브로 통하기
        </Box>
        <SpaceBox height={25} />
        <Box
          sx={{
            textAlign: 'center',
            color: 'text.secondary',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '22px',
            opacity: 0.8,
          }}
        >
          AI가 분석한 5글자 카드 뒤에 숨어,
          <br />
          애쓰지 않아도 내 상태를 가장 힙하게 보여주기
        </Box>
      </Box>
      <SpaceBox height={70} smHeight={80} />
      <Box
        sx={{
          display: { xs: 'block', sm: 'none' },
          width: '100vw',
          marginLeft: '50%',
          transform: 'translateX(-50%)',
          overflow: 'hidden',
          position: 'relative',
          paddingBottom: '12px',
        }}
      >
        <Box
          sx={{
            width: 'min(323px, calc(100vw - 67px))',
            margin: 'auto',
            position: 'relative',
            zIndex: 1,
            cursor: 'pointer',
            paddingBottom: '12px',
          }}
          onClick={() => {
            setIsDailyFiveFlipped((prev) => !prev);
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8.8px',
              marginBottom: '10px',
              paddingLeft: '6px',
            }}
          >
            <Box
              component="img"
              src={activeDailyFiveCard.profileSrc}
              alt=""
              sx={{
                width: '34px',
                height: '34px',
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0,
              }}
            />
            <Box>
              <Box
                sx={{
                  color: 'text.primary',
                  fontSize: '11.3px',
                  fontWeight: 700,
                  lineHeight: '16.01px',
                }}
              >
                {activeDailyFiveCard.name}
              </Box>
              <Box
                sx={{
                  color: 'text.secondary',
                  fontSize: '11.3px',
                  fontWeight: 700,
                  lineHeight: '16.01px',
                  opacity: 0.6,
                }}
              >
                {activeDailyFiveCard.time}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: 'min(323px, calc(100vw - 67px))',
              perspective: '1000px',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: '22px',
                transformStyle: 'preserve-3d',
                transition: 'transform 0.6s ease',
                transform: isDailyFiveFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                transformOrigin: 'center center',
                willChange: 'transform',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '22px',
                  overflow: 'hidden',
                  backfaceVisibility: 'hidden',
                }}
              >
                <Box
                  component="img"
                  src={activeDailyFiveCard.imageSrc}
                  alt=""
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    objectFit: 'cover',
                  }}
                />
                <Box sx={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.4)' }} />
                <Box
                  sx={{
                    position: 'absolute',
                    top: '11px',
                    right: '11px',
                    width: '33.900875px',
                    height: '33.900875px',
                    borderRadius: '28.26px',
                    border: '0.94px solid rgba(255, 255, 255, 0.3)',
                    gap: '1.88px',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <DailyFiveFlipIcon width={18.837207794189453} height={18.837207794189453} />
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: '34px',
                    color: 'white',
                    textAlign: 'center',
                  }}
                >
                  <Box
                    sx={{
                      fontFamily: 'NeoDunggeunmo, NanumSquare Neo, sans-serif',
                      fontSize: '30.14px',
                      fontWeight: 400,
                      lineHeight: '100%',
                      textShadow: '0px 0px 2.17px rgba(0, 0, 0, 0.2)',
                    }}
                  >
                    {activeDailyFiveCard.keyword}
                  </Box>
                  <Box
                    sx={{
                      marginTop: '7.5px',
                      color: 'rgba(255, 255, 255, 0.5)',
                      fontSize: '10.36px',
                      fontWeight: 700,
                      lineHeight: '13.19px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '2px',
                    }}
                  >
                    <DailyFiveTwinkleIcon width={13.2} height={13.2} />
                    <Box component="span">AI가 생성한 키워드</Box>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '22px',
                  overflow: 'hidden',
                  backfaceVisibility: 'hidden',
                  transform: 'rotateY(180deg)',
                }}
              >
                <Box
                  component="img"
                  src={activeDailyFiveCard.imageSrc}
                  alt=""
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    objectFit: 'cover',
                    filter: 'blur(12px)',
                    transform: 'scale(1.08)',
                  }}
                />
                <Box sx={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.34)' }} />
                <Box
                  sx={{
                    position: 'absolute',
                    top: '11px',
                    right: '11px',
                    width: '33.900875px',
                    height: '33.900875px',
                    borderRadius: '28.26px',
                    border: '0.94px solid rgba(255, 255, 255, 0.3)',
                    gap: '1.88px',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <DailyFiveFlipIcon width={18.837207794189453} height={18.837207794189453} />
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '260px',
                    maxWidth: '82%',
                    textAlign: 'center',
                    color: 'white',
                  }}
                >
                  <Box
                    sx={{
                      fontSize: '14px',
                      fontWeight: 700,
                      lineHeight: '21.04px',
                      wordBreak: 'keep-all',
                    }}
                  >
                    {activeDailyFiveCard.record}
                  </Box>
                  <Box
                    sx={{
                      marginTop: '13px',
                      color: 'rgba(255, 255, 255, 0.62)',
                      fontSize: '13px',
                      fontWeight: 700,
                      lineHeight: '18.94px',
                    }}
                  >
                    김멈블님이 작성한 기록
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: 'calc(34px + 10px + 30.685px)',
            left: 'calc(50% + 172.5px)',
            width: '261.63px',
            height: '261.63px',
            borderRadius: '18px',
            overflow: 'hidden',
            pointerEvents: 'none',
          }}
        >
          <Box
            component="img"
            src={peekDailyFiveCard.imageSrc}
            alt=""
            sx={{
              width: '100%',
              height: '100%',
              display: 'block',
              objectFit: 'cover',
            }}
          />
          <Box sx={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.3)' }} />
          <Box sx={{ position: 'absolute', inset: 0, background: 'rgba(255, 255, 255, 0.6)' }} />
        </Box>
      </Box>
      <Box
        sx={{
          display: { xs: 'none', sm: 'flex' },
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: { sm: 'calc(100vw - 40px)' },
          maxWidth: { sm: '1178.4px' },
          marginLeft: { sm: '50%' },
          transform: { sm: 'translateX(-50%)' },
          gap: { xs: '8px', sm: '16.8px' },
          overflow: 'visible',
          position: 'relative',
        }}
      >
        {dailyFiveCards.map((card) => (
          <Box
            key={card.imageSrc}
            sx={{
              width: {
                xs: 'calc((100% - 16px) / 3)',
                sm: card.isActive
                  ? 'min(400px, calc((100% - 33.6px) * 400 / 1144.8))'
                  : 'min(372.4px, calc((100% - 33.6px) * 372.4 / 1144.8))',
              },
              opacity: card.isActive ? 1 : 0.5,
              marginTop: { sm: card.isActive ? '0px' : '16px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: '5px', sm: '10.8px' },
                paddingX: { xs: '1px', sm: '3.7px' },
                marginBottom: { xs: '7px', sm: '10.2px' },
              }}
            >
              {card.profileSrcs.length > 1 ? (
                <Box
                  sx={{
                    position: 'relative',
                    width: { xs: '22px', sm: '41px' },
                    height: { xs: '22px', sm: '41px' },
                    flexShrink: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={card.profileSrcs[1]}
                    alt=""
                    sx={{
                      position: 'absolute',
                      right: 0,
                      bottom: 0,
                      width: { xs: '14px', sm: '26px' },
                      height: { xs: '14px', sm: '26px' },
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                  <Box
                    component="img"
                    src={card.profileSrcs[0]}
                    alt=""
                    sx={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      width: { xs: '15px', sm: '27px' },
                      height: { xs: '15px', sm: '27px' },
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
              ) : (
                <Box
                  component="img"
                  src={card.profileSrc}
                  alt=""
                  sx={{
                    width: { xs: '20px', sm: card.isActive ? '41.9px' : '39px' },
                    height: { xs: '20px', sm: card.isActive ? '41.9px' : '39px' },
                    borderRadius: '50%',
                    objectFit: 'cover',
                    flexShrink: 0,
                  }}
                />
              )}
              <Box sx={{ minWidth: 0 }}>
                <Box
                  sx={{
                    color: 'text.primary',
                    fontSize: { xs: '8px', sm: card.isActive ? '15.1px' : '14.1px' },
                    fontWeight: 800,
                    lineHeight: { xs: '11px', sm: card.isActive ? '21px' : '19.5px' },
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {card.name}
                </Box>
                <Box
                  sx={{
                    color: 'text.secondary',
                    fontSize: { xs: '8px', sm: card.isActive ? '14px' : '13px' },
                    fontWeight: 700,
                    lineHeight: { xs: '11px', sm: card.isActive ? '19.8px' : '18.4px' },
                    opacity: 0.6,
                  }}
                >
                  {card.time}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                position: 'relative',
                aspectRatio: '1 / 1',
                perspective: '1000px',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: { xs: '14px', sm: card.isActive ? '28px' : '25px' },
                  transformStyle: 'preserve-3d',
                  transition: 'transform 0.6s ease',
                  transform:
                    card.isActive && isDailyFiveFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: { xs: '14px', sm: card.isActive ? '28px' : '25px' },
                    overflow: 'hidden',
                    backfaceVisibility: 'hidden',
                  }}
                >
                  <Box
                    component="img"
                    src={card.imageSrc}
                    alt=""
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'block',
                      objectFit: 'cover',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      background: card.isActive ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.3)',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: { xs: '4%', sm: card.isActive ? '13.9px' : '12.9px' },
                      right: { xs: '4%', sm: card.isActive ? '14.7px' : '12.9px' },
                      width: { xs: '22px', sm: card.isActive ? '41.9px' : '39px' },
                      height: { xs: '22px', sm: card.isActive ? '41.9px' : '39px' },
                      borderRadius: '50%',
                      border: '1.08px solid rgba(255, 255, 255, 0.3)',
                      color: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: { xs: '13px', sm: '22px' },
                      fontWeight: 800,
                    }}
                  >
                    <DailyFiveFlipIcon width="55%" height="55%" />
                  </Box>
                  <Box
                    sx={{
                      position: 'absolute',
                      left: 0,
                      right: 0,
                      bottom: { xs: '18px', sm: card.isActive ? '28.7px' : '26.8px' },
                      textAlign: 'center',
                      color: 'white',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: { xs: '14px', sm: card.isActive ? '37.2px' : '34.7px' },
                        fontWeight: 400,
                        lineHeight: 'normal',
                        fontFamily: 'NeoDunggeunmo, NanumSquare Neo, sans-serif',
                        textShadow: '0px 0px 2.17px rgba(0, 0, 0, 0.2)',
                      }}
                    >
                      {card.keyword}
                    </Box>
                    <Box
                      sx={{
                        marginTop: { xs: '3px', sm: card.isActive ? '9.3px' : '8.7px' },
                        color: 'rgba(255, 255, 255, 0.5)',
                        fontSize: { xs: '7px', sm: card.isActive ? '12.8px' : '11.9px' },
                        fontWeight: 700,
                        lineHeight: { xs: '10px', sm: card.isActive ? '16.3px' : '15.2px' },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: { xs: '1px', sm: card.isActive ? '2.3px' : '2.2px' },
                      }}
                    >
                      <DailyFiveTwinkleIcon
                        width={card.isActive ? 16.3 : 15.2}
                        height={card.isActive ? 16.3 : 15.2}
                      />
                      <Box component="span">AI가 생성한 키워드</Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: { xs: '14px', sm: card.isActive ? '28px' : '25px' },
                    overflow: 'hidden',
                    backfaceVisibility: 'hidden',
                    transform: 'rotateY(180deg)',
                  }}
                >
                  <Box
                    component="img"
                    src={card.imageSrc}
                    alt=""
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'block',
                      objectFit: 'cover',
                      filter: 'blur(12px)',
                      transform: 'scale(1.08)',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      background: 'rgba(0, 0, 0, 0.34)',
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: { xs: '4%', sm: card.isActive ? '13.9px' : '12.9px' },
                      right: { xs: '4%', sm: card.isActive ? '14.7px' : '12.9px' },
                      width: { xs: '22px', sm: card.isActive ? '41.9px' : '39px' },
                      height: { xs: '22px', sm: card.isActive ? '41.9px' : '39px' },
                      borderRadius: '50%',
                      border: '1.08px solid rgba(255, 255, 255, 0.3)',
                      color: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: { xs: '13px', sm: '22px' },
                      fontWeight: 800,
                    }}
                  >
                    <DailyFiveFlipIcon width="55%" height="55%" />
                  </Box>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      width: { xs: '78%', sm: '280px' },
                      transform: 'translate(-50%, -50%)',
                      textAlign: 'center',
                      color: 'white',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: { xs: '9px', sm: '16px' },
                        fontWeight: 700,
                        lineHeight: { xs: '14px', sm: '26px' },
                        wordBreak: 'keep-all',
                      }}
                    >
                      {card.record}
                    </Box>
                    <Box
                      sx={{
                        marginTop: { xs: '7px', sm: '18px' },
                        color: 'rgba(255, 255, 255, 0.62)',
                        fontSize: { xs: '7px', sm: '14px' },
                        fontWeight: 700,
                        lineHeight: { xs: '10px', sm: '20px' },
                      }}
                    >
                      김멈블님이 작성한 기록
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
        <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            position: 'absolute',
            top: '-67px',
            left: '-134px',
            width: '316px',
            height: '602px',
            pointerEvents: 'none',
            background: 'linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
            opacity: 0.7,
            zIndex: 2,
          }}
        />
        <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            position: 'absolute',
            top: '-67px',
            right: '-134px',
            width: '316px',
            height: '602px',
            pointerEvents: 'none',
            background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
            opacity: 0.7,
            zIndex: 2,
          }}
        />
      </Box>
    </Box>
  );
}

function PingSection() {
  return (
    <Box sx={{ paddingX: '20px', maxWidth: { sm: '600px', margin: 'auto' } }}>
      <DescriptionSection
        subTitle="멈블이 뭔데?"
        mainTitle="핑!하고 시작되는 재밌는 대화"
        description="툭 던져도 받아주고 핑 날려도 받아주는 사이, <br/>말은 아끼고 마음은 전하는 방법"
      />
      <SpaceBox height={70} smHeight={112} />
      <Box
        sx={{
          justifyContent: 'flex-end',
          display: { xs: 'none', sm: 'flex' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            borderRadius: '30px',
            backgroundColor: 'primary.light',
            padding: '9px 16px',
            alignItems: 'center',
            opacity: { xs: '60%', sm: '100%' },
          }}
        >
          <Box sx={{ marginRight: '4px', display: 'flex' }}>
            <Box sx={{ width: '24px' }} component={'img'} src={'/images/smile.png'} />
          </Box>
          <Box
            sx={{ fontWeight: 700, color: 'primary.main', fontSize: { xs: '12px', sm: '15px' } }}
          >
            52개의 핑을 날렸어요
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <SpaceBox smHeight={12} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            borderRadius: '30px',
            backgroundColor: 'primary.light',
            padding: { xs: '6px 12px', sm: '9px 16px' },
            alignItems: 'center',
            opacity: { xs: '60%', sm: '100%' },
          }}
        >
          <Box sx={{ marginRight: '4px', display: 'flex' }}>
            <Box
              sx={{ width: { xs: '20px', sm: '24px' } }}
              component={'img'}
              src={'/images/chicken.png'}
            />
          </Box>
          <Box
            sx={{ fontWeight: 700, color: 'primary.main', fontSize: { xs: '12px', sm: '15px' } }}
          >
            12개의 핑을 날렸어요
          </Box>
        </Box>
      </Box>
      <SpaceBox height={18} smHeight={49} />
      <Box sx={{ display: 'inline-block' }}>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            borderRadius: '30px',
            backgroundColor: 'secondary.main',
            padding: { xs: '6px 12px', sm: '12.5px 16px' },
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: '20px', marginRight: '4px', display: { xs: 'flex', sm: 'none' } }}>
            <Box sx={{ width: '20px' }} component={'img'} src={'/images/congrates.png'} />
          </Box>
          <Box sx={{ width: '40px', marginRight: '4px', display: { xs: 'none', sm: 'flex' } }} />
          <Box
            sx={{
              fontWeight: 700,
              color: 'secondary.light',
              fontSize: { xs: '12px', sm: '15px' },
            }}
          >
            428개의 핑을 날렸어요
          </Box>
          <Box
            sx={{
              position: 'absolute',
              left: '-91px',
              top: '-194px',
              display: { xs: 'none', sm: 'block' },
            }}
          >
            <Box sx={{ width: '300px' }} component={'img'} src={'/images/confetti.png'} />
          </Box>
        </Box>
      </Box>
      <SpaceBox height={18} smHeight={24} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            borderRadius: '30px',
            backgroundColor: 'primary.light',
            padding: { xs: '6px 11px 5px 10px', sm: '8px 16px' },
            alignItems: 'center',
          }}
        >
          <Box sx={{ marginRight: '4px', display: 'flex' }}>
            <Box
              sx={{
                width: { xs: '20px', sm: '24px' },
                height: { xs: '20px', sm: '24px' },
                marginBottom: { xs: '2px' },
              }}
              component={'img'}
              src={'/images/thumb_up.png'}
            />
          </Box>
          <Box
            sx={{ fontWeight: 700, color: 'primary.main', fontSize: { xs: '12px', sm: '15px' } }}
          >
            12개의 핑을 날렸어요
          </Box>
        </Box>
      </Box>

      <SpaceBox height={108} smHeight={252} />
      <Box sx={{ display: 'flex', justifyContent: 'center', height: { sx: '46px', sm: '70px' } }}>
        <Box
          sx={{
            border: '0.11px solid #0000000F',
            boxShadow: '0px 4.39px 10.98px 0px #0000001A',
            fontWeight: 700,
            color: 'text.primary',
            width: '100%',
            borderRadius: { xs: '25px', sm: '100px' },
            padding: { xs: '15px 20px 14px 20px', sm: '25px 30px' },
            fontSize: { xs: '14px', sm: '19px' },
            maxWidth: { sm: '400px' },
          }}
        >
          뭐해..? 대신 센스있게 핑!{' '}
        </Box>
        <SpaceBox width={8} smWidth={12} />
        <Box
          sx={{
            border: '0.11px solid #0000000F',
            boxShadow: '0px 4.39px 10.98px 0px #0000001A',
            padding: { xs: '10px', sm: '15px 16px 15px 15px' },
            borderRadius: { xs: '30px', sm: '100px' },
          }}
        >
          <Box sx={{ position: 'relative' }}>
            <Box
              sx={{
                width: { xs: '25px', sm: '38px' },
                height: { xs: '25px', sm: '38px' },
                display: 'block',
              }}
              component={'img'}
              src={'/images/thumb_up.png'}
            />
            <Box
              sx={{
                width: '80px',
                position: 'absolute',
                top: '-103px',
                left: '-30px',
                rotate: '-15deg',
                animation: 'fly 2s linear infinite',
                '@keyframes fly': {
                  '0%': { display: 'none', top: '-103px', left: '-30px', opacity: 1 },
                  '1%': { display: 'block', top: '-103px', left: '-30px', opacity: 1 },
                  '33%': { opacity: 0.5 },
                  '66%': { top: '-400px', left: '-30px', opacity: 0 },
                  '67%': { display: 'none' },
                  '100%': { display: 'none' },
                },
              }}
            >
              <Box sx={{ position: 'absolute' }}>
                <Box sx={{ width: '23px' }} component={'img'} src={'/images/star.png'} />
              </Box>
              <Lottie animationData={thumbUpAnimationData} loop={true} />
            </Box>
            <Box
              sx={{
                width: '80px',
                position: 'absolute',
                top: '-103px',
                left: '-15px',
                rotate: '15deg',
                opacity: 0,
                animation: 'fly 2s linear infinite',
                animationDelay: '0.5s',
                '@keyframes fly': {
                  '0%': { display: 'none', top: '-103px', left: '-15px', opacity: 1 },
                  '1%': { display: 'block', top: '-103px', left: '-15px', opacity: 0 },
                  '2%': { opacity: 1 },
                  '33%': { opacity: 0.5 },
                  '66%': { top: '-400px', left: '-15px', opacity: 0 },
                  '67%': { display: 'none' },
                  '100%': { display: 'none' },
                },
              }}
            >
              <Lottie animationData={thumbUpAnimationData} loop={true} />
              <Box sx={{ width: '23px' }} component={'img'} src={'/images/star.png'} />
            </Box>
            <Box
              sx={{
                width: '80px',
                position: 'absolute',
                top: '-103px',
                left: '-50px',
                opacity: 0,
                animation: 'fly 2s linear infinite',
                animationDelay: '1s',
                '@keyframes fly': {
                  '0%': { display: 'none', top: '-103px', opacity: 1 },
                  '1%': { display: 'block', top: '-103px', opacity: 0 },
                  '2%': { opacity: 1 },
                  '33%': { opacity: 0.5 },
                  '66%': { top: '-400px', opacity: 0 },
                  '67%': { display: 'none' },
                  '100%': { display: 'none' },
                },
              }}
            >
              <Box sx={{ width: '23px' }} component={'img'} src={'/images/star.png'} />
              <Lottie animationData={thumbUpAnimationData} loop={true} />
            </Box>
            <Box
              sx={{
                width: '80px',
                position: 'absolute',
                top: '-103px',
                left: '-30px',
                opacity: 0,
                animation: 'fly 2s linear infinite',
                animationDelay: '1.5s',
                '@keyframes fly': {
                  '0%': { display: 'none', top: '-103px', opacity: 1 },
                  '1%': { display: 'block', top: '-103px', opacity: 0 },
                  '2%': { opacity: 1 },
                  '33%': { opacity: 0.5 },
                  '66%': { top: '-400px', opacity: 0 },
                  '67%': { display: 'none' },
                  '100%': { display: 'none' },
                },
              }}
            >
              <Box sx={{ width: '23px' }} component={'img'} src={'/images/star.png'} />
              <Lottie animationData={thumbUpAnimationData} loop={true} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function TimeCapsuleSection() {
  return (
    <Box sx={{ paddingX: '20px' }}>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <DescriptionSection
          subTitle="그때 되면 알려줄게"
          mainTitle="기다릴수록 더 궁금해지는 타임캡슐"
          description="예상 못 한 타이밍에 터지는 기다리면 재밌고<br/> 안 보면 궁금증 폭발하는 타임캡슐 메시지"
        />
      </Box>
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        <DescriptionSection
          subTitle="그때 되면 알려줄게"
          mainTitle="기다릴수록<br/>더 궁금해지는 타임캡슐"
          description="예상 못 한 타이밍에 터지는 기다리면 재밌고<br/> 안 보면 궁금증 폭발하는 타임캡슐 메시지"
        />
      </Box>
      <SpaceBox height={70} smHeight={110} />
      <Box sx={{ maxWidth: { sm: '600px' }, margin: { sm: 'auto' } }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Box
            sx={{
              marginLeft: { xs: '6px' },
              marginRight: { xs: '5px', sm: '14px' },
              width: { xs: '24px', sm: '54px' },
            }}
            component="img"
            src="/images/conversatoin_profile.png"
          />
          <Box>
            <Box
              sx={{
                backgroundColor: 'secondary.main',
                borderRadius: '20px 30px 30px 8px',
                fontWeight: 700,
                color: 'text.primary',
                display: 'inline-block',
                padding: { xs: '14px 16px', sm: '16px 22px' },
                fontSize: { xs: '13px', sm: '17px' },
              }}
            >
              너 내일 약속있어?
            </Box>
            <SpaceBox height={4} smHeight={6}></SpaceBox>
            <Box
              sx={{
                backgroundColor: 'secondary.main',
                borderRadius: '8px 30px 30px 20px',
                fontWeight: 700,
                color: 'text.primary',
                padding: { xs: '14px 16px', sm: '16px 22px' },
                fontSize: { xs: '13px', sm: '17px' },
              }}
            >
              없으면 나랑 롯데월드 가자
            </Box>
          </Box>
        </Box>
        <SpaceBox height={14} smHeight={30}></SpaceBox>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box
            sx={{
              marginRight: { xs: '6px' },
              backgroundColor: 'primary.main',
              borderRadius: '30px',
              fontWeight: 700,
              color: 'white',
              padding: { xs: '14px 16px', sm: '16px 22px' },
              fontSize: { xs: '13px', sm: '17px' },
            }}
          >
            12시간 후에 알랴줌
          </Box>
        </Box>
        <SpaceBox height={10} smHeight={15} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ width: { xs: '155px', sm: '215px' }, position: 'relative' }}>
            <Lottie animationData={timeCapsuleAnimationData} loop={true} />
            <Box
              sx={{
                fontFamily: 'Wellbutrin',
                position: 'absolute',
                color: 'white',
                fontSize: { xs: '11px', sm: '15px' },
                top: { xs: '157px', sm: '218px' },
                left: { xs: '58px', sm: '80px' },
              }}
            >
              12:00
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

function PungSection() {
  return (
    <Box sx={{ paddingX: '20px' }}>
      <DescriptionSection
        subTitle="우리끼리 비밀이 어딨어"
        mainTitle="사라질거니까 말할게, 뿅!"
        description="티 안 나게 심어두는 일회용 폭탄, 대화방을 나가면 뿅!<br/>기록 없이 사라지는 한 마디"
      />
      <SpaceBox height={70}></SpaceBox>
      <Box sx={{ width: { xs: '200px', sm: '300px' }, margin: 'auto' }}>
        <Lottie animationData={pungAnimationData} loop={true} />
      </Box>
    </Box>
  );
}

function MumbleBoxSection() {
  return (
    <Box sx={{ paddingX: '20px' }}>
      <DescriptionSection
        subTitle="친구 한정 서프라이즈"
        mainTitle="궁금하면 열어봐, 멈블박스"
        description="친구에게 하고 싶은 말을 담아서 보내면<br/>열자마자 웃음이 터지는 멈블박스"
      />
      <Box sx={{ margin: 'auto', width: { xs: '200px', sm: '300px' }, position: 'relative' }}>
        <Lottie animationData={mBoxOpenAnimationData} loop={true} />
        <Box
          sx={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
            width: '100%',
            height: '135px',
            position: 'absolute',
            top: '0px',
          }}
        />
        <Box
          sx={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
            width: '100%',
            height: '135px',
            position: 'absolute',
            top: '0px',
          }}
        />
      </Box>
    </Box>
  );
}

function DownloadSection({
  setIsOpen,
  isMobile,
}: {
  setIsOpen: (v: boolean) => void;
  isMobile: boolean;
}) {
  return (
    <Box sx={{ backgroundColor: '#FCF9FB' }}>
      <SpaceBox height={120} smHeight={170}></SpaceBox>
      <Box
        sx={{
          fontWeight: 800,
          textAlign: 'center',
          color: 'text.primary',
          fontSize: { xs: '22px', sm: '32px' },
          lineHeight: { sm: '66px' },
        }}
      >
        지금 멈블을 시작해 보세요
      </Box>
      <SpaceBox height={18} smHeight={14} />
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            fontSize: '13px',
            fontWeight: 800,
            color: 'white',
            backgroundColor: 'primary.main',
            padding: '11px 15px',
            borderRadius: '20px',
            cursor: 'pointer',
          }}
          onClick={() => {
            if (isMobile) {
              window.open('https://lobster-mumble.onelink.me/64Km/ew5fiob4');
            } else {
              setIsOpen(true);
            }
          }}
        >
          앱 다운로드
        </Box>
      </Box>
      <SpaceBox height={16} smHeight={40}></SpaceBox>

      <Box sx={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
        <Box sx={{ position: 'relative', zIndex: 3 }}>
          <Box
            component={'img'}
            src="/images/phone_mobile.png"
            sx={{
              display: { xs: 'block', sm: 'none' },
              position: 'relative',
              width: '270px',
              height: '260px',
              zIndex: 3,
            }}
          />
          <Box
            component={'img'}
            src="/images/phone_pc.png"
            sx={{
              display: { xs: 'none', sm: 'block' },
              position: 'relative',
              width: '551px',
              height: '533px',
              zIndex: 3,
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              zIndex: 2,
              background: 'linear-gradient(90deg, rgba(252, 249, 251, 0) 0%, #FCF9FB 90.48%)',
              top: '25px',
              left: { xs: '-50px', sm: '-90px' },
              width: { xs: '90px', sm: '150px' },
              height: { xs: '216px', sm: '400px' },
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              zIndex: 2,
              background: 'linear-gradient(270deg, rgba(252, 249, 251, 0) 0%, #FCF9FB 90.48%)',
              top: '25px',
              right: { xs: '-50px', sm: '-90px' },
              width: { xs: '90px', sm: '150px' },
              height: { xs: '216px', sm: '400px' },
            }}
          />
        </Box>

        <Box
          sx={{
            position: 'absolute',
            top: { xs: '120px', sm: '240px' },
            left: '0px',
            zIndex: 1,
          }}
        >
          <InfiniteMarquee />
        </Box>
      </Box>
    </Box>
  );
}

export default App;
